import { objectSchema } from "vue-utils"
import { Nullable } from "../BaseEntity"

export interface MarriageSignature {
	SignatureSVG: Nullable<string>
	SignaturePoints: Nullable<string>
	AgreeToTerms: Nullable<boolean>
}

export const MarriageSignature = objectSchema<MarriageSignature>({
	SignatureSVG: Nullable(String),
	SignaturePoints: Nullable(String),
	AgreeToTerms: Nullable(Boolean),
})
